import {
    formatSeriesData,
    getSeriesColors,
} from './Charts/MultiPredictionTimeSeriesChart/utils';
import { forwardRef, memo } from 'react';
import Chart from './Charts/MultiPredictionTimeSeriesChart';
import { CombinedTimeSeriesOverview } from 'components/TimeSeriesOverview';
import { GOOGLE_METADATA_BY_KEY } from 'utils/metrics';
import { StatDisplay } from '../TimeSeriesOverview';
import TimeSeriesKey from './TimeSeriesKey';
import { calculateData } from 'utils/helpers';
import { timeseries as copy } from '@/copy';
import { getAverageTimeSeries } from './utils/index';
import isEqual from 'react-fast-compare';
import styled from 'styled-components';

const defaultGoogleMetrics = [
    GOOGLE_METADATA_BY_KEY.volume,
    GOOGLE_METADATA_BY_KEY.YoY,
    GOOGLE_METADATA_BY_KEY.QoQ,
    GOOGLE_METADATA_BY_KEY.MoM,
];

const defaultPredictionMetrics = [GOOGLE_METADATA_BY_KEY.predictedYoY];

const WatchlistTimeSeriesWrapper = styled.div`
    display: flex;
    flex-direction: column;
`;

const WatchlistTimeSeries = memo(
    forwardRef(
        (
            {
                data,
                isLoading,
                noDataMessage,
                viewSumTimeSeries,
                Wrapper = WatchlistTimeSeriesWrapper,
                skipPrediction = false,
                ...props
            },
            ref,
        ) => {
            let maybeSumData = data;

            if (viewSumTimeSeries && data && data.length) {
                const { accessors } = formatSeriesData(data);
                maybeSumData = [
                    {
                        id: 'combined',
                        timeSeries: getAverageTimeSeries(data, accessors),
                        color: getSeriesColors(0),
                        name: 'Combined',
                    },
                ];
            }

            const { volume, ...metrics } = isLoading
                ? {}
                : calculateData(data) || {};
            const combinedMetricsList = defaultGoogleMetrics.slice(1);

            return (
                <div
                    css={`
                        position: relative;
                    `}
                    ref={ref}
                >
                    <Chart
                        chartHeight={350}
                        data={maybeSumData}
                        isLoading={isLoading}
                        showPlaceholder={!data || data.length < 1}
                        placeholderMessage={
                            isLoading ? copy.loading : noDataMessage
                        }
                        Wrapper={Wrapper}
                        skipPrediction={skipPrediction}
                    >
                        <div
                            css={`
                                display: flex;
                                align-items: flex-start;
                                justify-content: space-between;
                            `}
                        >
                            <StatDisplay
                                volume={volume}
                                isLoading={isLoading}
                                valueKey="volume"
                                tooltipKey="volume"
                                contentKey="timeSeriesVolume"
                                labelPrefix="Avg. Monthly"
                                labelSuffix="Searches"
                            />
                            <CombinedTimeSeriesOverview
                                isLoading={isLoading}
                                metrics={
                                    metrics
                                        ? [
                                              {
                                                  metrics,
                                                  metricsList:
                                                      combinedMetricsList,
                                                  defaultMetric:
                                                      combinedMetricsList[0],
                                              },
                                          ]
                                        : null
                                }
                                predictionMetrics={
                                    metrics && !skipPrediction
                                        ? [
                                              {
                                                  metrics,
                                                  metricsList:
                                                      defaultPredictionMetrics,
                                                  defaultMetric:
                                                      defaultPredictionMetrics[0],
                                              },
                                          ]
                                        : null
                                }
                                predictionMetricsCss="margin-left: auto;"
                                showDataSource={false}
                                showDataSourceBar={false}
                                customCss="display: block;"
                                wrapperCss="width: 74%; padding: 0 16px;"
                            />
                        </div>
                    </Chart>
                    {!viewSumTimeSeries ? (
                        <TimeSeriesKey
                            data={data}
                            style={{ display: 'none', marginTop: '1em' }}
                            className="image-download-visible"
                        />
                    ) : null}
                </div>
            );
        },
    ),
    isEqual,
);

export default WatchlistTimeSeries;
